import dayjs from "dayjs";
import { formatDateRange } from "../../UI/Utils/formatDate.ts";

export function formatWeek({
  week,
  year,
}: {
  week: number;
  year: number;
}): string {
  const startDateUtc = dayjs().week(week).year(year).startOf("week");
  const endDateUtc = startDateUtc.endOf("week");
  return formatDateRange(startDateUtc, endDateUtc, { withWeekday: true });
}
